// extracted by mini-css-extract-plugin
module.exports = {"banner-section":"Home_banner-section__1j04T","banner-content":"Home_banner-content__1rsMK","typicalAnimation":"Home_typicalAnimation__3f15f"};